import { render, staticRenderFns } from "./infoView.vue?vue&type=template&id=2d3010a2&scoped=true"
import script from "./infoView.vue?vue&type=script&lang=js"
export * from "./infoView.vue?vue&type=script&lang=js"
import style0 from "./infoView.vue?vue&type=style&index=0&id=2d3010a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3010a2",
  null
  
)

export default component.exports